import React, { useEffect, useState, useRef } from 'react';

/* 1. HomePageHeroCard fade effects */
export function FadeInFromLeft({ children, delayClass }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.1 });
    if(ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`fade-in-left ${visible ? 'visible' : ''} ${delayClass}`}
    >
      {children}
    </div>
  );
}

export function ImageSlideIn({ src, alt = "Image", style }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if(entry.isIntersecting){
        setVisible(true);
        observer.disconnect();
      }
    }, {threshold: 0.1});
    if(ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <img
      ref={ref}
      src={src}
      alt="Malemahadeswara god logo"
      style={{ width: '220%', maxWidth: '800px' }}
      className={`h-auto opacity-80 select-none slide-in-right${visible ? ' visible' : ''}`}
      draggable={false}
    />
  );
}
/* ---------ends here-------- */

/* 2. CTASectionCard fade effects */
export function FadeInFromBottomWhenVisible({ children }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.15 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`cta-fade-bottom ${visible ? "visible" : ""}`}
    >
      {children}
    </div>
  );
}
/* ---------ends here-------- */

/* 3. StatsBlock fade effects */
export function useFadeInOnScroll() {
  const ref = useRef();
  const [isVisible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return [ref, isVisible];
}
/* ---------ends here-------- */